export default __webpack_public_path__ + "38a277fb848199ed894ee1f5e4b41cc6.svg";